import { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import AnalyticsHeader from "./components/AnalyticsHeader";
import AnalyticsTable from "./components/AnalyticsTable";
import { getUserLedger } from "../../config/LiveApi";

const UserAnalytics = () => {
  const [tableData, setTableData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMerchant, setSelectedMerchant] = useState(null);

useEffect(() => {
    fetchLedger();
  }, [selectedMerchant]);

// console.log("Selected Merchant in UserAnalytics:", selectedMerchant);

const fetchLedger = async () => {
    setIsLoading(true);
    try {
      const response = await getUserLedger(
        selectedMerchant?.value || ""
      );
      setTableData(response || {});
    } catch (error) {
      console.error("Ledger Fetch Error:", error);
      setTableData({});
    } finally {
      setIsLoading(false);
    }
  };

  // ✅ Excel Download Function
  const handleDownload = () => {
    if (!tableData?.dateRanges?.length) return;

    const excelData = tableData.dateRanges.map((item) => ({
      Date: item.date,
      "# of Payin": item.payinData?.totalPayinCount || 0,
      "Payin Amount": item.payinData?.requestAmountPayin || 0,
      "Payin Fee": item.payinData?.totalComissionPayin || 0,
      "Rolling Reserve": item.payinData?.rollingReserve || 0,
      "# of Payout(Settled)": item.payoutData?.settled?.count || 0,
      "Payout Amount(Settled)": item.payoutData?.settled?.requestAmount || 0,
      "Payout Fee(Settled)": item.payoutData?.settled?.totalComission || 0,
      "# of Payout(Pending)": item.payoutData?.processing?.count || 0,
      "Payout Amount(Pending)": item.payoutData?.processing?.requestAmount || 0,
      "Payout Fee(Pending)": item.payoutData?.processing?.totalComission || 0,
      "Chargeback Amount": item.chargebackData?.amount || 0,
      "Chargeback Penalty": item.chargebackData?.penalty || 0,
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Ledger Report");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    saveAs(blob, `Ledger_Report.xlsx`);
  };

  return (
    <div>
      <AnalyticsHeader onDownload={handleDownload}
      selectedMerchant={selectedMerchant}
        setSelectedMerchant={setSelectedMerchant} />
      <AnalyticsTable tableData={tableData} isLoading={isLoading} />
    </div>
  );
};

export default UserAnalytics;